import { FontWeight } from '@quicktools/shared-components';
import noSelect from '@quicktools/shared-components/styles/noselect';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  '@global': {
    '*': {
      margin: 0,
      padding: 0,
      boxSizing: 'border-box',
    },
    html: {
      height: '100%',
      '-webkit-overflow-scrolling': 'touch',
    },
    body: {
      height: '100%',
      ...noSelect,
    },

    '#root': {
      height: '100%',
      width: '100%',
    },

    '@keyframes spin': {
      from: { transform: 'rotate(0deg)' },
      to: { transform: 'rotate(360deg)' },
    },
  },

  ctaGenerateColors: {
    borderRadius: '72px',
    padding: '12px 24px',
    fontSize: '16px',
    fontWeight: FontWeight.SemiBold,
  },
});

export default useStyles;
